<template>
  <div class="pedidos-page">
    <b-overlay :show="$store.getters['PTC_PedidosClient/getIsLoading']" variant="light" opacity="0.85" blur="2px">

      <PageHeader
        title="Pedidos de Vendas"
        :breadcrumbs="[
          { text: 'Operações', to: { name: 'dashboard-ptc' } },
          { text: 'Pedidos de Vendas' }
        ]"
      >
        <template #actions>
          <button class="btn-action-secondary" @click="exportData" v-if="pedidos.length > 0">
            <feather-icon icon="DownloadIcon" size="16" />
            Exportar
          </button>
          <button class="btn-action-primary" @click="novoPedido">
            <feather-icon icon="PlusIcon" size="16" />
            Novo Pedido
          </button>
        </template>
      </PageHeader>

      <b-modal v-model="showModalNF" size="lg" title="Nota Fiscal" hide-footer modal-class="modal-pdf">
        <iframe :src="pdfUrlNF" width="100%" height="600px"></iframe>
      </b-modal>

      <b-modal v-model="showModal" size="lg" title="Relatório Pedido" hide-footer modal-class="modal-pdf">
        <div v-if="isLoadingPdf" class="text-center p-4">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2 text-muted">Gerando PDF...</p>
        </div>
        <iframe v-else :src="pdfUrl" width="100%" height="600px"></iframe>
      </b-modal>

      <CollapsibleFilters
        :active-filters-count="activeFiltersCount"
        :initial-expanded="false"
        @search="filters('filter')"
        @clear="limpar"
        ref="filtersComponent"
      >
        <div class="filter-field">
          <label class="filter-label">Nº Pedido</label>
          <input
            type="text"
            class="filter-input"
            placeholder="Digite o número"
            v-model="items.nrPedido_PW"
          />
        </div>

        <div class="filter-field">
          <label class="filter-label">Período De</label>
          <input
            type="date"
            class="filter-input"
            v-model="items.de"
          />
        </div>

        <div class="filter-field">
          <label class="filter-label">Período Até</label>
          <input
            type="date"
            class="filter-input"
            v-model="items.ate"
          />
        </div>

        <div class="filter-field">
          <label class="filter-label">Data Entrega</label>
          <input
            type="date"
            class="filter-input"
            v-model="items.dataEntrega"
          />
        </div>

        <div class="filter-field">
          <label class="filter-label">Cliente ID ERP</label>
          <input
            type="text"
            class="filter-input"
            placeholder="Código ERP"
            v-model="items.codClienteERP"
          />
        </div>

        <div class="filter-field">
          <label class="filter-label">Razão Social</label>
          <input
            type="text"
            class="filter-input"
            placeholder="Nome do cliente"
            v-model="items.razaoSocialCliente"
          />
        </div>

        <div class="filter-field">
          <label class="filter-label">Tipo</label>
          <select class="filter-input" v-model="selected">
            <option v-for="opt in options" :key="opt.value" :value="opt.value" :disabled="opt.disabled">
              {{ opt.text }}
            </option>
          </select>
        </div>

        <div class="filter-field">
          <label class="filter-label">Situação</label>
          <select class="filter-input" v-model="selectedSit">
            <option v-for="opt in optionsSit" :key="opt.value" :value="opt.value" :disabled="opt.disabled">
              {{ opt.text }}
            </option>
          </select>
        </div>
      </CollapsibleFilters>

      <div class="table-card">
        <div class="table-header">
          <div class="table-header-left">
            <span class="table-count">
              <feather-icon icon="PackageIcon" size="16" />
              {{ pedidos.length }} {{ pedidos.length === 1 ? 'pedido' : 'pedidos' }}
            </span>
          </div>
          <div class="table-header-right">
            <div class="per-page-control">
              <label>Exibir:</label>
              <select v-model="perPage" class="per-page-select">
                <option v-for="opt in pageOptions" :key="opt" :value="opt">{{ opt }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="data-table">
            <thead>
              <tr>
                <th class="th-center">Pedido</th>
                <th class="th-center">Pedido ERP</th>
                <th>Cliente</th>
                <th>Razão Social</th>
                <th>Tipo</th>
                <th class="th-center">Emissão</th>
                <th class="th-center">Prev. Fatur.</th>
                <th class="th-right">Valor Total</th>
                <th class="th-center">Situação</th>
                <th class="th-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="paginatedItems.length === 0">
                <td colspan="10" class="empty-state">
                  <div class="empty-content">
                    <feather-icon icon="InboxIcon" size="40" />
                    <p>Nenhum registro encontrado</p>
                  </div>
                </td>
              </tr>
              <tr v-for="(item, index) in paginatedItems" :key="index" @click="detalhesPedido(item)" class="table-row-clickable">
                <td class="td-center">
                  <span class="cell-code">{{ item.nrPedido_PW }}</span>
                </td>
                <td class="td-center">
                  <span class="cell-code-secondary">{{ item.nrPedido_ERP || '-' }}</span>
                </td>
                <td>
                  <span class="cell-text-truncate" :title="item.codClienteERP">{{ item.codClienteERP }}</span>
                </td>
                <td>
                  <span class="cell-text-truncate" :title="item.razaoSocialCliente">{{ item.razaoSocialCliente }}</span>
                </td>
                <td>
                  <span class="cell-text-small">{{ item.nomeTipoPedido || '-' }}</span>
                </td>
                <td class="td-center">
                  <span class="cell-date">{{ item.dataEmissao }}</span>
                </td>
                <td class="td-center">
                  <span class="cell-date">{{ item.dataEntrega === 'Invalid date' ? '-' : item.dataEntrega || '-' }}</span>
                </td>
                <td class="td-right">
                  <span class="cell-value">{{ formatCurrency(item.valorTotalPedido) }}</span>
                </td>
                <td class="td-center">
                  <StatusBadge :text="item.pedidoSituacao" />
                </td>
                <td class="td-center" @click.stop>
                  <div class="action-buttons">
                    <button class="btn-icon-action" title="Ver detalhes" @click="detalhesPedido(item)">
                      <feather-icon icon="EyeIcon" size="16" />
                    </button>
                    <button class="btn-icon-action" title="Imprimir" @click="exibirModalPdf(item)">
                      <feather-icon icon="PrinterIcon" size="16" />
                    </button>
                    <button class="btn-icon-action" title="Nota Fiscal" @click="goToNotaFiscal">
                      <feather-icon icon="FileTextIcon" size="16" />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer" v-if="pedidos.length > 0">
          <div class="pagination-info">
            Mostrando {{ paginationStart }} a {{ paginationEnd }} de {{ pedidos.length }} registros
          </div>
          <div class="pagination-controls">
            <button class="pagination-btn" :disabled="currentPage === 1" @click="currentPage = 1">
              <feather-icon icon="ChevronsLeftIcon" size="16" />
            </button>
            <button class="pagination-btn" :disabled="currentPage === 1" @click="currentPage--">
              <feather-icon icon="ChevronLeftIcon" size="16" />
            </button>
            <div class="pagination-pages">
              <button
                v-for="page in visiblePages"
                :key="page"
                class="pagination-page"
                :class="{ 'is-active': page === currentPage }"
                @click="currentPage = page"
              >
                {{ page }}
              </button>
            </div>
            <button class="pagination-btn" :disabled="currentPage === totalPages" @click="currentPage++">
              <feather-icon icon="ChevronRightIcon" size="16" />
            </button>
            <button class="pagination-btn" :disabled="currentPage === totalPages" @click="currentPage = totalPages">
              <feather-icon icon="ChevronsRightIcon" size="16" />
            </button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { VBTooltip, BButton, BFormSelect } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import PTC_PedidosService from '@/services/PTC/PTC_Pedidos.service';
import { mapGetters } from 'vuex';
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import FilesService from '@/services/Operacoes/files.service';
import CollapsibleFilters from './components/CollapsibleFilters.vue';
import PageHeader from './components/PageHeader.vue';
import StatusBadge from './components/StatusBadge.vue';

const ptc_pedidosService = new PTC_PedidosService();
const filesService = new FilesService();

export default {
  components: {
    BFormSelect,
    BButton,
    CollapsibleFilters,
    PageHeader,
    StatusBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataDash: this.$route.params.dataDash || null,
      situacaoPedido: this.$route.params.situacaoPedido || null,
      items: {
        nrPedido_PW: '',
        de: '',
        ate: '',
        dataEntrega: '',
        codClienteERP: '',
        razaoSocialCliente: '',
      },
      selected: null,
      options: [
        { value: null, text: '-- Todos --', disabled: false },
      ],
      selectedSit: null,
      optionsSit: [
        { value: null, text: '-- Todos --', disabled: false },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      showModal: false,
      showModalNF: false,
      pdfUrl: '',
      pdfUrlNF: '',
      isLoadingPdf: false,
    };
  },
  watch: {
    'items.de': function (newVal) {
      this.updateDataDash();
    },
    'items.ate': function (newVal) {
      this.updateDataDash();
    },
    perPage(newVal) {
      this.currentPage = 1;
    },
    pedidos: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.populateTypeOptions();
          this.populateSitOptions();
        }
        const maxPage = Math.ceil((newVal?.length || 0) / this.perPage) || 1;
        if (this.currentPage > maxPage) {
          this.currentPage = maxPage;
        }
      },
      deep: true,
    },
  },
  methods: {
    formatCurrency(value) {
      if (!value && value !== 0) return '-';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    updateDataDash() {
      this.dataDash = {
        de: this.items.de,
        ate: this.items.ate,
      };
    },
    novoPedido() {
      this.$router.push({ name: 'pedidos-vendas-create' });
    },
    exportData() {
      console.log('Exportar dados...');
    },
    goToNotaFiscal() {
      this.$router.push({ name: 'notaFiscal', params: { dataDash: this.dataDash } });
    },
    async exibirModalPdf(data) {
      try {
        this.showModal = true;
        this.isLoadingPdf = true;

        await filesService.indexFiles(data.nrPedido_PW);
        this.pdfUrl = this.$store.state.filesStore.generatedLabelUrl;
      } catch (error) {
        console.error('Erro ao gerar o PDF:', error);
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: 'Não foi possível gerar o PDF. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.showModal = false;
      } finally {
        this.isLoadingPdf = false;
      }
    },
    async getPedidos() {
      await ptc_pedidosService.retornaPedidos();
      this.items = { ...this.items, ...this.pedidos };
      this.populateTypeOptions();
      this.populateSitOptions();
    },
    async baixarNotaFiscal(data) {
      try {
        const url = `ptc/danf?EstabelecimentoId=${data.codEstabelecimento}&NotaFiscalNumero=0394761&notafiscalserie=${data.NotaFiscal[0].numeroSerie}`;
        this.$store.commit('PTC_PedidosClient/SET_IS_LOADING', true);
        const response = await axios.get(url);
        this.pdfUrlNF = response.data;
        this.showModalNF = true;
        this.$store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: 'Não foi possível gerar a Nota Fiscal.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.$store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
      }
    },
    async detalhesPedido(pedido) {
      await this.$router.push({
        name: 'pedido_detalhe',
        params: {
          id: pedido.nrPedido_PW,
        },
      });
    },
    async filters() {
      const query = {};

      if (this.items.nrPedido_PW) {
        query.nrPedido_PW = this.items.nrPedido_PW;
      }

      if (this.items.codClienteERP) {
        query.codClienteERP = this.items.codClienteERP;
      }

      if (this.items.razaoSocialCliente) {
        query.razaoSocialCliente = this.items.razaoSocialCliente;
      }

      if (this.selected !== null) {
        query.nomeTipoPedido = this.selected;
      }

      const dePreenchido = this.items.de !== null && this.items.de !== '' && this.items.de !== undefined;
      const atePreenchido = this.items.ate !== null && this.items.ate !== '' && this.items.ate !== undefined;

      if ((!dePreenchido && !atePreenchido) || (dePreenchido && atePreenchido)) {
        if (dePreenchido && atePreenchido) {
          query.DataEmissaoDe = this.items.de;
          query.DataEmissaoAte = this.items.ate;
        }
      } else if (dePreenchido) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Atenção',
            text: 'Preencha o campo "Até" quando "De" estiver preenchido.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      } else if (atePreenchido) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Atenção',
            text: 'Preencha o campo "De" quando "Até" estiver preenchido.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (this.items.dataEntrega) {
        query.dataEntrega = this.items.dataEntrega;
      }

      if (this.selectedSit !== null) {
        query.pedidoSituacao = this.selectedSit;
      }

      await ptc_pedidosService.retornaPedidos(query);
      this.currentPage = 1;

      if (this.$refs.filtersComponent) {
        this.$refs.filtersComponent.collapse();
      }
    },
    populateTypeOptions() {
      if (this.pedidos && this.pedidos.length > 0) {
        const uniqueTypes = [...new Set(this.pedidos.map((pedido) => pedido.nomeTipoPedido))];
        this.options = [{ value: null, text: '-- Todos --', disabled: false }];
        uniqueTypes.forEach(type => {
          if (type) {
            this.options.push({ value: type, text: type });
          }
        });
      }
    },
    populateSitOptions() {
      if (this.pedidos && this.pedidos.length > 0) {
        const uniqueSit = [...new Set(this.pedidos.map((pedido) => pedido.pedidoSituacao))];
        this.optionsSit = [{ value: null, text: '-- Todos --', disabled: false }];
        uniqueSit.forEach(type => {
          if (type) {
            this.optionsSit.push({ value: type, text: type });
          }
        });
      }
    },
    async limpar() {
      this.items = {
        nrPedido_PW: '',
        de: '',
        ate: '',
        dataEntrega: '',
        codClienteERP: '',
        razaoSocialCliente: '',
      };
      this.dataDash = null;
      this.selected = null;
      this.selectedSit = null;
      await ptc_pedidosService.retornaPedidos();
      this.currentPage = 1;
    },
  },
  async mounted() {
    let query = {};

    if (this.dataDash !== null && this.dataDash !== '') {
      this.items.de = this.dataDash.dataInicial;
      this.items.ate = this.dataDash.dataFinal;
      query = {
        DataEmissaoDe: this.dataDash.dataInicial,
        DataEmissaoAte: this.dataDash.dataFinal,
      };
    }

    if (this.situacaoPedido) {
      query.pedidoSituacao = this.situacaoPedido;
      this.selectedSit = this.situacaoPedido;
    }

    await ptc_pedidosService.retornaPedidos(query);

    this.populateTypeOptions();
    this.populateSitOptions();
  },
  computed: {
    ...mapGetters({
      pedidos: 'PTC_PedidosClient/getPedidos',
    }),
    paginatedItems() {
      const items = this.pedidos;
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return items.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.pedidos.length / this.perPage) || 1;
    },
    paginationStart() {
      return ((this.currentPage - 1) * this.perPage) + 1;
    },
    paginationEnd() {
      const end = this.currentPage * this.perPage;
      return end > this.pedidos.length ? this.pedidos.length : end;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      let start = Math.max(1, current - 2);
      let end = Math.min(total, current + 2);

      if (end - start < 4) {
        if (start === 1) {
          end = Math.min(5, total);
        } else {
          start = Math.max(1, total - 4);
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
    activeFiltersCount() {
      let count = 0;
      if (this.items.nrPedido_PW) count++;
      if (this.items.de) count++;
      if (this.items.ate) count++;
      if (this.items.dataEntrega) count++;
      if (this.items.codClienteERP) count++;
      if (this.items.razaoSocialCliente) count++;
      if (this.selected) count++;
      if (this.selectedSit) count++;
      return count;
    },
  },
};
</script>

<style lang="scss" scoped>
.pedidos-page {
  padding: 1.5rem;
  min-height: 100vh;
  background: var(--sf-bg, #f5f7fa);
}

.btn-action-primary,
.btn-action-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-action-primary {
  background: var(--sf-primary, #5d54d4);
  color: #ffffff;

  &:hover {
    background: var(--sf-primary-dark, #4a43a8);
    box-shadow: 0 4px 12px rgba(93, 84, 212, 0.3);
  }
}

.btn-action-secondary {
  background: var(--sf-surface-bg, #ffffff);
  color: var(--sf-text-secondary, #3d4250);
  border: 1px solid var(--sf-border-light, #e5e8f0);

  &:hover {
    background: var(--sf-surface-hover, #f0f2f8);
    border-color: var(--sf-border, #d0d4e0);
  }
}

.table-card {
  background: var(--sf-surface-bg, #ffffff);
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-radius: 12px;
  overflow: hidden;
  margin-top: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--sf-border-light, #e5e8f0);
  background: var(--sf-surface-secondary, #f8f9fc);
}

.table-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.table-count {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--sf-text-primary, #2f2b3d);

  svg {
    color: var(--sf-primary, #5d54d4);
  }
}

.table-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  label {
    font-size: 0.8125rem;
    color: var(--sf-text-muted, #5f6472);
  }
}

.per-page-select {
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-radius: 6px;
  background: var(--sf-surface-bg, #ffffff);
  color: var(--sf-text-primary, #2f2b3d);
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: var(--sf-primary, #5d54d4);
  }
}

.table-responsive {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 0.875rem 1rem;
    text-align: left;
    border-bottom: 1px solid var(--sf-border-light, #e5e8f0);
  }

  th {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--sf-text-muted, #5f6472);
    background: var(--sf-surface-secondary, #f8f9fc);
    white-space: nowrap;
  }

  td {
    font-size: 0.875rem;
    color: var(--sf-text-primary, #2f2b3d);
  }

  tbody tr {
    transition: background 0.15s ease;

    &:hover {
      background: var(--sf-surface-hover, #f5f6fa);
    }

    &:last-child td {
      border-bottom: none;
    }
  }
}

.table-row-clickable {
  cursor: pointer;
}

.th-center, .td-center {
  text-align: center;
}

.th-right, .td-right {
  text-align: right;
}

.cell-code {
  font-weight: 600;
  color: var(--sf-primary, #5d54d4);
}

.cell-code-secondary {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8125rem;
  color: var(--sf-text-muted, #5f6472);
}

.cell-text-truncate {
  display: block;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-text-small {
  font-size: 0.8125rem;
  color: var(--sf-text-secondary, #3d4250);
}

.cell-date {
  font-size: 0.8125rem;
  color: var(--sf-text-muted, #5f6472);
  white-space: nowrap;
}

.cell-value {
  font-weight: 600;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.875rem;
  color: var(--sf-success, #177f46);
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}

.btn-icon-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-radius: 6px;
  background: var(--sf-surface-bg, #ffffff);
  color: var(--sf-text-muted, #5f6472);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--sf-primary-light, rgba(93, 84, 212, 0.1));
    border-color: var(--sf-primary, #5d54d4);
    color: var(--sf-primary, #5d54d4);
  }
}

.empty-state {
  padding: 3rem !important;
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: var(--sf-text-muted, #5f6472);

  svg {
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 0.9375rem;
  }
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--sf-border-light, #e5e8f0);
  background: var(--sf-surface-secondary, #f8f9fc);
}

.pagination-info {
  font-size: 0.8125rem;
  color: var(--sf-text-muted, #5f6472);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-radius: 6px;
  background: var(--sf-surface-bg, #ffffff);
  color: var(--sf-text-muted, #5f6472);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: var(--sf-surface-hover, #f0f2f8);
    border-color: var(--sf-border, #d0d4e0);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.pagination-pages {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0 0.25rem;
}

.pagination-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 0.5rem;
  font-size: 0.8125rem;
  font-weight: 500;
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-radius: 6px;
  background: var(--sf-surface-bg, #ffffff);
  color: var(--sf-text-secondary, #3d4250);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--sf-surface-hover, #f0f2f8);
  }

  &.is-active {
    background: var(--sf-primary, #5d54d4);
    border-color: var(--sf-primary, #5d54d4);
    color: #ffffff;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sf-text-muted, #5f6472);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-input {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid var(--sf-border-light, #e5e8f0);
  border-radius: 6px;
  background: var(--sf-surface-bg, #ffffff);
  color: var(--sf-text-primary, #2f2b3d);
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--sf-primary, #5d54d4);
    box-shadow: 0 0 0 3px rgba(93, 84, 212, 0.1);
  }

  &::placeholder {
    color: var(--sf-text-muted, #5f6472);
    opacity: 0.6;
  }
}

body.dark-layout {
  .pedidos-page {
    background: var(--sf-bg, #161d31);
  }

  .btn-action-secondary {
    background: var(--sf-surface-bg, #283046);
    color: var(--sf-text-secondary, #b4b7bd);
    border-color: var(--sf-border-light, #3b4253);

    &:hover {
      background: var(--sf-surface-hover, #2d3548);
    }
  }

  .table-card {
    background: var(--sf-surface-bg, #283046);
    border-color: var(--sf-border-light, #3b4253);
  }

  .table-header {
    background: var(--sf-surface-secondary, #242b3d);
    border-bottom-color: var(--sf-border-light, #3b4253);
  }

  .data-table {
    th {
      background: var(--sf-surface-secondary, #242b3d);
      color: var(--sf-text-muted, #b4b7bd);
    }

    th, td {
      border-bottom-color: var(--sf-border-light, #3b4253);
    }

    td {
      color: var(--sf-text-primary, #d0d2d6);
    }

    tbody tr:hover {
      background: var(--sf-surface-hover, #2d3548);
    }
  }

  .cell-code {
    color: var(--sf-primary-light, #a5b4fc);
  }

  .cell-code-secondary {
    color: var(--sf-text-muted, #b4b7bd);
  }

  .cell-value {
    color: var(--sf-success, #4ade80);
  }

  .per-page-select,
  .filter-input {
    background: var(--sf-surface-bg, #283046);
    border-color: var(--sf-border-light, #3b4253);
    color: var(--sf-text-primary, #d0d2d6);
  }

  .btn-icon-action {
    background: var(--sf-surface-bg, #283046);
    border-color: var(--sf-border-light, #3b4253);
    color: var(--sf-text-muted, #b4b7bd);

    &:hover {
      background: rgba(93, 84, 212, 0.2);
      color: var(--sf-primary-light, #a5b4fc);
    }
  }

  .table-footer {
    background: var(--sf-surface-secondary, #242b3d);
    border-top-color: var(--sf-border-light, #3b4253);
  }

  .pagination-btn,
  .pagination-page {
    background: var(--sf-surface-bg, #283046);
    border-color: var(--sf-border-light, #3b4253);
    color: var(--sf-text-muted, #b4b7bd);

    &:hover:not(:disabled) {
      background: var(--sf-surface-hover, #2d3548);
    }

    &.is-active {
      background: var(--sf-primary, #5d54d4);
      border-color: var(--sf-primary, #5d54d4);
      color: #ffffff;
    }
  }
}

@media (max-width: 768px) {
  .pedidos-page {
    padding: 1rem;
  }

  .table-header,
  .table-footer {
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
  }

  .table-header-right {
    justify-content: flex-end;
  }

  .pagination-controls {
    justify-content: center;
  }

  .pagination-info {
    text-align: center;
  }

  .action-buttons {
    flex-wrap: wrap;
  }
}
</style>
